// The lesson's homework, under the lesson's content: the brief — the plain
// text an older brief was written as, then its blocks (video, audio, an
// embedded page, pictures, formatted text, lesson materials) — and below it
// what the learner has handed in and the form to hand in more (Homework).
//
// The brief's blocks are drawn by the lesson's own BlockView, so they look
// exactly like the lesson; `trackProgress={false}` because nothing in a brief
// is lesson media: its video plays freely and reports no progress.

import type { Homework as Brief, Submission } from '../../api'
import { BlockView } from '../../components/Blocks'
import type { Block } from '../../components/Blocks'
import { useT } from '../../i18n'
import m from '../../i18n/homework'
import { Homework } from '../Homework'
import '../../styles/homework.css'

export type LessonHomeworkProps = {
  lectureId: string
  /** The brief as GET /learn/lectures/{id} carries it; `blocks` is absent from an older server. */
  homework: Brief & { blocks?: Block[] }
  /** A piece of work just handed in, for the lesson to fold into what it shows. */
  onSubmitted: (s: Submission) => void
}

export default function LessonHomework({ lectureId, homework, onSubmitted }: LessonHomeworkProps) {
  const t = useT(m)
  const blocks = (Array.isArray(homework.blocks) ? homework.blocks : []).slice().sort((a, b) => a.seq - b.seq)
  const lead = homework.instructions.trim()

  return (
    <section className="homework" aria-labelledby="homework-title">
      <h2 id="homework-title">{t('title')}</h2>
      {(lead !== '' || blocks.length > 0) && (
        <div className="homework-brief" role="group" aria-label={t('briefLabel')}>
          {lead !== '' && <p className="homework__brief">{homework.instructions}</p>}
          {blocks.map((block) => (
            <BlockView key={block.id} block={block} trackProgress={false} />
          ))}
        </div>
      )}
      {/* Keyed by the homework: the form reads its kept draft once, and must
          never carry one homework's answer over into another's. */}
      <Homework key={homework.id} lectureId={lectureId} homework={homework} onSubmitted={onSubmitted} />
    </section>
  )
}
